import React, { Component } from "react";
import { closeIcon } from "../utils/images";
import OtpInput from "./otpInput";
import commonContext, { AppContext } from "../../common/context/common";
import { leadType } from "../../app";

interface IState {
    otp: string;
}
interface IProps {
    onClose: Function;
    handleOnOTPSubmit: Function;
    timer?: string;
    buttonText?: string;
    resendOTP?: Function;
}
export class OtpPopUp extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;

    constructor(props: IProps) {
        super(props);
        this.state = {
            otp: "",
        };
    }
    handleChange = (otp: any) => {
        const { setLead } = this.context;
        this.setState({ otp });
        setLead({ otp: otp });
    };

    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.setLead = (this.context as AppContext).setLead;
        return (
            <>
                <div
                    className="modal fixed w-full h-full top-0 left-0 flex justify-center items-end sm:items-center z-50"
                    id="otpModal"
                >
                    <div className="modal-overlay absolute w-full h-full bg-black opacity-50"></div>
                    <div className="modal-container bg-white w-11/12 sm:w-6/12 lg:w-5/12 mx-auto rounded shadow-lg z-50 overflow-y-auto mb-2 sm:mb-0">
                        {/* <!-- Add margin if you want to see some of the overlay behind the modal--> */}
                        <div className="modal-content  text-left py-2 px-2 md:py-3 md:px-3 lg:py-6 lg:px-6">
                            <div
                                className="w-full modal-close cursor-pointer z-50 float-right"
                                onClick={() => this.props.onClose()}
                            >
                                <img
                                    src={closeIcon}
                                    title="Close"
                                    alt="Close"
                                />
                            </div>
                            <div className="w-full mt-8 mx-auto">
                                <h2 className="openSans-Light text-black mt-3 mb-3 text-2xl md:text-3xl lg:text-3xl xl:text-4xl">
                                    OTP
                                </h2>
                                <div className="openSans-Reg text-black text-sm md:text-lg xl:text-xl">
                                    <p className="openSans-Light text-black text-sm md:text-lg xl:text-xl">
                                        We sent you an OTP on your registered
                                        number ending with{" "}
                                        {((this.lead
                                            .mobile as unknown) as string).substr(
                                            ((this.lead
                                                .mobile as unknown) as string)
                                                .length - 4
                                        )}
                                    </p>
                                    <div className="w-full my-8">
                                        <form>
                                            <div className="w-full flex flex-wrap mx-auto">
                                                <OtpInput
                                                    value={this.state.otp}
                                                    onChange={this.handleChange}
                                                    numInputs={6}
                                                    inputStyle="otpinput w-full focus:border-red-500 active:border-red-500 block text-base lg:text-lg xl:text-xl border-b-2 border-gray-200 mx-1 text-black text-center"
                                                    containerStyle=""
                                                    placeholder=""
                                                    isInputNum={true}
                                                />
                                            </div>
                                        </form>
                                    </div>
                                    <p className="text-center openSans-Reg text-track text-sm mb-6">
                                        {this.props.timer}
                                    </p>
                                    <p className="text-center openSans-Reg text-red-600 text-sm mb-6">
                                        {this.lead.otpAttemptsLeftText ? (
                                            <>
                                                Only {this.lead.otpAttemptsLeft}{" "}
                                                attempts left
                                            </>
                                        ) : (
                                            ""
                                        )}
                                    </p>
                                    <p className="text-center">
                                        <a
                                            href="javascript:;"
                                            onClick={() =>
                                                this.props.resendOTP()
                                            }
                                            className="blue-link-color no-underline hover:underline hover:text-black text-sm md:text-base lg:text-lg xl:text-lg transition-all openSans-SemiBold text-center"
                                            title="Resend OTP"
                                        >
                                            Resend OTP
                                        </a>
                                    </p>
                                    <div className="relative w-full md:w-4/12 mx-auto my-4 text-center">
                                        <button
                                            className={
                                                "button-blue-bg text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue " +
                                                this.lead.loadingBtn
                                            }
                                            title="Disburse Loan"
                                            onClick={() =>
                                                this.props.handleOnOTPSubmit()
                                            }
                                        >
                                            {this.props.buttonText
                                                ? this.props.buttonText
                                                : "Disburse Loan"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default OtpPopUp;
